import { useEffect } from 'react';
import { useScript } from 'usehooks-ts';
import { useStyle } from './useStyle';

const PWA_SCRIPT_SOURCE_URL =
	'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.991/dist/add-to-homescreen.min.js';
const PWA_SCRIPT_CSS_SOURCE_URL =
	'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.991/dist/add-to-homescreen.min.css';
const PWA_ASSETS_BASE_URL =
	'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.991/dist/assets/img/';

export const usePwaPrompt = () => {
	const scriptStatus = useScript(PWA_SCRIPT_SOURCE_URL, { removeOnUnmount: true });
	const stylesStatus = useStyle(PWA_SCRIPT_CSS_SOURCE_URL, { removeOnUnmount: true });

	useEffect(() => {
		if (scriptStatus !== 'ready' || stylesStatus !== 'ready') {
			return;
		}

		if (window.AddToHomeScreenInstance) {
			return;
		}

		window.AddToHomeScreenInstance = window.AddToHomeScreen({
			appName: 'Pletly Care',

			appIconUrl: 'pwa/apple-touch-icon/apple-touch-icon-180.png',
			assetUrl: PWA_ASSETS_BASE_URL,

			displayOptions: { showMobile: true, showDesktop: false },
			allowClose: true,
			maxModalDisplayCount: 1,
		});

		window.AddToHomeScreenInstance.show();
	}, [scriptStatus, stylesStatus]);
};
